import { useGetUserProfileFetch } from '@hooks/fetch/useUserFetch';
import { setUser } from '@sentry/nextjs';
import { ReactNode, useEffect } from 'react';

type Props = {
  readonly children: ReactNode;
};

export default function SentryManager({ children }: Props) {
  const { getUserProfileFetchData: user } = useGetUserProfileFetch();

  useEffect(() => {
    if (!!user) {
      setUser({
        email: user.email,
        id: user.id?.toString(),
        username: user.name,
        companyName: user.company_name,
      });
    } else {
      setUser(null);
    }
  }, [user]);

  return <>{children}</>;
}
